import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icon", "className", "contentClassName"];
import { cva } from 'class-variance-authority';
import { CommandItem } from "../../_shadcn-native-components/command";
import { cn } from "../../utils";
import { sanitizeText } from "../utils/sanitize-text";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ICON_VARIANTS = {
  "default": 'tw-bg-neutral-light-300 dark:tw-bg-neutral-dark-600 tw-text-neutral-light-700 dark:tw-text-neutral-dark-300 group-aria-selected:tw-bg-neutral-light-200 dark:group-aria-selected:tw-bg-neutral-dark-500',
  'default-selected': 'tw-text-primary-light-500 dark:tw-text-secondary-dark-500 dark:tw-bg-neutral-dark-700 dark:group-aria-selected:tw-bg-neutral-dark-700',
  primary: 'tw-text-primary-light-500 tw-bg-primary-light-100',
  'primary-selected': 'tw-text-primary-light-500 tw-bg-primary-light-100',
  success: 'tw-text-success-500 tw-bg-success-100 tw-bg-success-100',
  'success-selected': 'tw-text-success-500 tw-bg-success-100',
  alert: 'tw-text-alert-500 tw-bg-alert-100 tw-bg-alert-100',
  'alert-selected': 'tw-text-alert-500 tw-bg-alert-100',
  info: 'tw-text-info-500 tw-bg-info-100',
  'info-selected': 'tw-text-info-500 tw-bg-info-100',
  disabled: 'tw-text-neutral-light-300 dark:tw-text-neutral-dark-300'
};
var iconVariants = /*#__PURE__*/cva('tw-min-h-4 tw-min-w-4 tw-rounded-full tw-flex tw-items-center tw-justify-center', {
  variants: {
    variant: ICON_VARIANTS
  },
  defaultVariants: {
    variant: 'default'
  }
});
var getParsedVariant = function getParsedVariant(_ref) {
  var _ref$iconColorVariant = _ref.iconColorVariant,
    iconColorVariant = _ref$iconColorVariant === void 0 ? 'default' : _ref$iconColorVariant,
    isSelected = _ref.isSelected;
  return isSelected ? "".concat(iconColorVariant, "-selected") : iconColorVariant;
};
export var DropdownIconItem = function DropdownIconItem(_ref2) {
  var _itemProps$selected;
  var icon = _ref2.icon,
    className = _ref2.className,
    contentClassName = _ref2.contentClassName,
    itemProps = _objectWithoutProperties(_ref2, _excluded);
  var iconColorVariant = icon.iconColorVariant;
  return /*#__PURE__*/_jsx(CommandItem, _objectSpread(_objectSpread({
    searchKey: icon.title,
    className: cn('tw-min-h-6.4', itemProps.selected && 'dark:tw-bg-neutral-dark-600', className, itemProps.disabled && 'tw-cursor-not-allowed tw-pointer-events-none tw-bg-neutral-light-400')
  }, itemProps), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-items-center tw-gap-0.8",
      children: [/*#__PURE__*/_jsx("div", {
        className: iconVariants({
          variant: getParsedVariant({
            iconColorVariant: itemProps.disabled ? 'default' : iconColorVariant,
            isSelected: !itemProps.disabled ? (_itemProps$selected = itemProps.selected) !== null && _itemProps$selected !== void 0 ? _itemProps$selected : false : false
          })
        }),
        children: icon.icon({
          size: 24,
          className: 'tw-text-inherit tw-flex-shrink-0'
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-flex-col tw-gap-0.4",
        children: [/*#__PURE__*/_jsx("div", {
          className: cn('tw-font-subtitle5 tw-line-clamp-1', contentClassName, itemProps.selected && !iconColorVariant && 'tw-text-neutral-light-800 dark:tw-text-neutral-light-100 group-aria-selected:tw-text-primary-light-500 dark:group-aria-selected:tw-text-primary-light-100', itemProps.selected && iconColorVariant && 'tw-text-neutral-light-800 dark:tw-text-neutral-light-100', itemProps.disabled && 'tw-text-neutral-light-700 dark:tw-text-neutral-light-200'),
          children: sanitizeText(icon.title)
        }), icon.description && /*#__PURE__*/_jsx("div", {
          className: cn('tw-font-body5 tw-line-clamp-1 tw-text-neutral-light-700 dark:tw-text-neutral-dark-300', contentClassName),
          children: sanitizeText(icon.description)
        })]
      })]
    })
  }));
};